import { render, staticRenderFns } from "./SecurityAgent.vue?vue&type=template&id=270cacf2&scoped=true"
import script from "./SecurityAgent.vue?vue&type=script&lang=js"
export * from "./SecurityAgent.vue?vue&type=script&lang=js"
import style0 from "./SecurityAgent.vue?vue&type=style&index=0&id=270cacf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cacf2",
  null
  
)

export default component.exports